<template>
    <div class="frcuc-container" @click="handleSelection">

        <!--Profile image | User details | Checkbox-->
        <div class="frcuc-details-container">
            <v-row class="pa-0 ma-0">
                <!--Profile image-->
                <v-col class="pa-0 ma-0 justify-center" cols="4">
                    <v-img v-if="user.profilePicFileURL !== null " @click="callUser" :src="user.profilePicFileURL" alt="user" class="frcuc-profileImage" :class="user.swappStatus === 0 " cover :height="imageSize" :width="imageSize"/>
                    <v-icon v-else class="icons8-person" color="lightgrey" :size="imageSize"/>
                    <!-- <pre>{{ user.profilePicFileURL }}</pre> -->
                </v-col>

                <v-col cols="8" class="pa-0 pl-4 ma-0">
                    <v-row>
                        
                        <div class="d-flex flex-column align-start ml-1" style="max-width: 160px">
                            <div class="black--text font-weight-bold text-capitalize text-truncate" style="max-width: 210px">{{ user.userName }}
                                <v-icon v-if="user.userIsFireMarshall" class="icons8-fire mr-2 mb-1" color="error" size="20"/>
                                <v-icon v-if="user.userIsFirstAider" class="icons8-clinic mb-1" color="success" size="20"/>
                            </div>
                            <div class="font-weight-bold body-2 darkgrey--text">{{ user.userType }}</div>
                            <div class="font-weight-bold caption grey--text text-truncate" style="max-width: 210px">{{ user.organisation.organisationName }}</div>

                        </div>
                        <v-spacer/>
                        <div class="pr-3">
                            <v-icon class="icons8-checkmark-yes" :color="isUserChecked ? 'success' : 'lightgrey'" size="40"/>
                        </div>
                    </v-row>
                    <v-row>
                        <div class="d-flex align-center mt-2">
                            <v-icon class="icons8-qr-code mr-1" size="32" :color="computedSwappStatus.color"/>
                            <!-- <app-text v-if="user.swappTime" category="text-default-bold">{{ computedSwappStatus.label }} <span :class="computedSwappTime.color" class="font-weight-regular ml-2"> {{ computedTimeAgo() }} at {{ this.$moment(user.swappTime, 'X').format('HH:mm') }}</span> </app-text> -->
                            <app-text category="text-default-bold">{{ computedSwappStatus.label }} <span :class="computedSwappTime.color" class="font-weight-regular ml-2"> {{ computedTimeAgo() }}</span> </app-text>
                        </div>
                    </v-row>
                    <!--Flags for records that may not reflect who is on site-->
                    <v-row v-if="computedAccountStatus || computedSwappedInTooLong">
                        <div class="d-flex flex-wrap align-center mt-1">
                            <v-chip v-if="computedAccountStatus" class="warning white--text mr-1 mb-1" x-small>{{ computedAccountStatus }}</v-chip>
                            <v-chip v-if="computedSwappedInTooLong" class="error white--text mb-1" x-small>{{ computedSwappedInTooLong }}</v-chip>
                        </div>
                    </v-row>
                    <!-- <div>computedSwappTime {{ computedSwappTime }}</div> -->
                    <!-- <div>{{ user.swappTime }}</div>
                    <div>{{ user.swappedTime }}</div> -->
                </v-col>
            </v-row>
        </div>


    </div>
</template>

<script>
export default {

    name: "fireRollCallUserCard",

    props: ['user'],

    data: () => ({

        imageSize: 108,
        isUserChecked: false,

    }),

    computed: {

        /** * Computed Swapp Status * * Return a color and label to signify if a user is SWAPPed in or out. * * @returns {{color: string, label: string}} */
        computedSwappStatus() {
            const t = this
            const swappStatus = t.$props.user.swappStatus
            let color = ''
            let label = ''

            if (swappStatus) {
                color = 'success'
                label = 'In'
            } else {
                color = 'lightgrey'
                label = 'Out'
            }

            return {color: color, label: label}
        },
        /** * Computed Swapp Time * * Calculate if the current user has ever SWAPPed in/out, if they have and it was today, * return the date and time. * If they have not, return a message. * * @returns {{color, label: string}} either the date and time, or a message */
        computedSwappTime() {
            const t = this
            let lastSwappDateTime
            let color

            // If the user has a last swapp dateTime
            if (t.$props.user.swappTime) {

                // Grab a reference to the last SWAPP datetime
                const lastSwapp = t.$props.user.swappTime

                // Grab a reference to the date now
                const dateTimeNow = t.$moment().format('DD/MM/YYYY')
                const lastSwappDT = t.$moment(lastSwapp).format('DD/MM/YYYY')

                // If the last swapp dateTime was today, assign the date and time
                if (dateTimeNow === lastSwappDT) {
                    color = 'grey'
                    lastSwappDateTime = 'Today ' + t.$moment(Number(lastSwapp)).format('@ HH:mm')
                }
                // If there is no SWAPP for today, render a message
                else {
                    color = 'grey'
                    lastSwappDateTime = 'More than a day ago'
                }
            }
            else if (t.$props.user.swappedTime) {

                // Grab a reference to the last SWAPP datetime
                const lastSwapp = t.$props.user.swappedTime

                // Grab a reference to the date now
                const dateTimeNow = t.$moment().format('DD/MM/YYYY')
                const lastSwappDT = t.$moment(lastSwapp).format('DD/MM/YYYY')

                // If the last swapp dateTime was today, assign the date and time
                if (dateTimeNow === lastSwappDT) {
                    color = 'grey'
                    lastSwappDateTime = 'Today ' + t.$moment(Number(lastSwapp)).format('@ HH:mm')
                }
                // If there is no SWAPP for today, render a message
                else {
                    color = 'grey'
                    lastSwappDateTime = 'More than a day ago'
                }
            }

        

            return {label: lastSwappDateTime, color: color + '--text'}

        },
        /** * Computed Account Status * * Return the user's account status if it isn't APPROVED, so it can be flagged on the roll call. * * @returns {string} */
        computedAccountStatus() {
            const userStatus = this.$props.user.userStatus
            return userStatus && userStatus !== 'APPROVED' ? userStatus : ''
        },
        /** * Computed Swapped In Too Long * * Flag a user who has been SWAPPed in longer than the 13 hour auto swap-out, or has no SWAPP time. * * @returns {string} label, or empty if the user isn't flagged */
        computedSwappedInTooLong() {
            const t = this
            if (parseInt(t.$props.user.swappStatus) !== 1) return ''

            const swappedTime = t.$moment(t.$props.user.swappedTime, 'X')
            if (!t.$props.user.swappedTime || !swappedTime.isValid()) return 'No SWAPP in time'
            if (t.$moment().diff(swappedTime, 'hours') < 13) return ''

            return 'In for ' + swappedTime.fromNow(true)
        }

    },

    methods: {
        /** * Handle Selection * * Toggle the isUserChecked property for the checkbox colouring. * Emit the selected User back to the parent (fireRollCallRegister.vue). */
        handleSelection() {
            const t = this

            t.isUserChecked = !t.isUserChecked

            t.$emit('fireRollCallSelection', t.$props.user)
        },
        /** * Call User * * Open a telephone prompt to call the selected User. */
        callUser() {
            window.open('tel:' + this.$props.user.userTelephone)
        },
        computedTimeAgo() {
            // get users swappTime and swappedTime, if user has both, check which is the latest
            var swappTime = this.$props.user.swappTime
            // console.log('swappTime', swappTime)
            var swappedTime = this.$props.user.swappedTime
            // console.log('swappedTime', swappedTime)
            var time
            // if (swappTime !== undefined && swappedTime !== undefined) {
            //     if (this.$moment(swappTime, 'x').isAfter(swappedTime, 'X') || this.$moment(swappTime, 'X').isSame(swappedTime, 'X')) {
            //         // check if swappTime is x or X
            //         if (swappTime.length === 13) {
            //             time = this.$moment(swappTime, 'x').format('X')
            //         } else {
            //             time = swappTime
            //         }
            //     } else {
            //         time = swappedTime
            //     }
            //     console.log('time both = ' + time)
            // } else if (swappedTime !== undefined) {
                time = swappedTime


            //     console.log('time swappedTime = ' + time)
            // }
            // else if (swappTime !== undefined) {
            //     if (swappTime.length === 13) {
            //         time = this.$moment(swappTime, 'x').format('X')
            //     } else {
            //         time = swappTime
            //     }
            //     console.log('time swappTime = ' + time)
            // } 

            // check if time is today
            if (this.$moment(time, 'X').isSame(new Date(), 'day')) {
                return 'Today at ' + this.$moment(time, 'X').format('HH:mm')
            // check if time is yesterday
            } else if (this.$moment(time, 'X').isSame(new Date().getDate() - 1, 'day')) {
                return 'Yesterday at ' + this.$moment(time, 'X').format('HH:mm')
                // check if time is before yesterday
            } else {
                console.log('time UNDEFINED = ' + time)
                return this.$moment(time, 'X').fromNow() + ' at ' + this.$moment(time, 'X').format('HH:mm')
            }
        },
        computedTimeAgoSwapp(time) {
            // check if time is today
            if (this.$moment(time, 'x').isSame(new Date(), 'day')) {
                return 'Today'
            // check if time is yesterday
            } else if (this.$moment(time, 'x').isSame(new Date().getDate() - 1, 'day')) {
                return 'Yesterday'
                // check if time is before yesterday
            } else {
                return this.$moment(time, 'x').fromNow()
            }
        },

    },

    mounted() {
        const t = this
        t.isUserChecked = !!t.$props.user.checked
    }

}
</script>

<style>
.frcuc-container {
    display: flex;
    flex-direction: column;

    background: white;
    border-radius: 5px;
    padding: 8px;

    animation: fadeIn 1s;
}

.frcuc-details-container {
    display: flex;
}

.frcuc-profileImage {
    border-radius: 5px;
}

.frcuc-greyScaleImage {
    filter: grayscale(100%);
}

</style>